import { render, staticRenderFns } from "./AmazonPrimeIcon.vue?vue&type=template&id=d48ca38a&scoped=true&"
import script from "./AmazonPrimeIcon.vue?vue&type=script&lang=js&"
export * from "./AmazonPrimeIcon.vue?vue&type=script&lang=js&"
import style0 from "./AmazonPrimeIcon.vue?vue&type=style&index=0&id=d48ca38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ca38a",
  null
  
)

export default component.exports